/** @format */

import React, { useEffect, useRef, useState } from "react";
import SideBar from "./SideBar";
import TopBar from "./TopBar";
import {
  responsiveDimension,
  ResponsiveStyles,
  ScreenDimension,
} from "../../config/responsiveDimension";
import { Box, styled } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RoutesPath } from "../../routes/RoutesPath";
import { SnackbarProvider } from "notistack";
import AdminLayout from "./AdminLayout";
import { getCookie } from "../../utils/cookies";
import { HandleUserApi } from "../../utils/apiConfig/UserApiCall";
import {
  updateAdminDetails,
  updateClientBrands,
} from "../../redux/slice/userSlice";
import { updatePermission } from "../../redux/slice/campaignSlice";
import Loader from "./Loader";
import { API_ROUTES } from "../../utils/apiConfig/apiRoutes";
import axios from "axios";

const PathLayout = ({ children, toggleTheme, theme }) => {
  const location = useLocation();

  const containerRef = useRef(null); // Ref for the scrollable container
  const headerRef = useRef(null); // Ref for the scrollable container
  const adminDetails = useSelector((state) => state.user.adminDetails);
  const [headerHeight, setHeaderHeight] = useState(0);
  const { MLG } = ScreenDimension();
  const [pageLoader, setPageLoader] = useState(false);
  const permission = useSelector((state) => state?.campaign?.permission);
  const Navigation = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    setHeaderHeight(headerRef?.current?.offsetHeight || 0);
  }, [headerRef?.current, location.pathname]);

  useEffect(() => {
    if (getCookie("ssoToken")) {
      if (permission?.length === 0) {
        handlePermission();
      } else setPageLoader(false);
    } else {
      dispatch(updateAdminDetails([]));
      dispatch(updatePermission([]));
      dispatch(updateClientBrands(null));
    }
  }, []);

  const handlePermission = async () => {
    setPageLoader(true);
    await HandleUserApi(dispatch, Navigation, getCookie("ssoToken"));
    setPageLoader(false);
  };

  const fetchUpdateClientBrandId = async (ClientId) => {
    setPageLoader(true);
    try {
      await axios.get(`${API_ROUTES.GET_SWITCH_CLIENTS}/${ClientId}`, {
        headers: {
          authorization: `Bearer ${getCookie("ssoToken")}`,
        },
      });
      await HandleUserApi(dispatch, Navigation, getCookie("ssoToken"));
    } catch (err) {
      console.log(err);
    } finally {
      setPageLoader(false);
    }
  };

  const handleSelect = (newValue, value) => {
    if (!newValue) return;
    dispatch(updateClientBrands(newValue));
    fetchUpdateClientBrandId(newValue?.id);
    // const formattedName = value?.ClientBrandName.toLowerCase().replace(
    //   /\s+/g,
    //   ""
    // );
    // Navigation(`/admin/${formattedName}/1/manageschedular`);
  };

  // useEffect(() => {
  //   if (!User?.length) {
  //     Navigation(RoutesPath.LOGIN, { replace: true });
  //   }
  // }, [User, location.pathname]);
  //   const noSideBarPages = [
  //  RoutesPath.LOGIN
  //   ];
  //   const noTopBarPages = [
  //    RoutesPath.LOGIN
  //   ];

  //   const isSpecialPage = noSideBarPages.includes(location.pathname);
  //   const isTopBarSpecialPage = noTopBarPages.includes(location.pathname);

  // const timesheet = "/"+location.pathname.split("/").slice(1, 2).join("/")
  const hide =
    location.pathname !== RoutesPath.LOGIN &&
    location.pathname !== RoutesPath.INITIAL_PAGE;

  return (
    <>
      {hide && (
        <Box ref={headerRef}>
          {adminDetails?.[0]?.is_superadmin === 1 && (
            <AdminLayout handleChange={handleSelect} />
          )}
          <TopBar toggleTheme={toggleTheme} theme={theme} />
        </Box>
      )}
      {!pageLoader && (
        <Box
          ref={containerRef}
          sx={{
            display: "flex",
            overflow: "auto",
            height: `calc(100vh - ${headerHeight}px)`,
          }}
        >
          {hide && <SideBar />}
          <Container
            sx={
              !hide
                ? { width: "100%" }
                : ResponsiveStyles({ width: { xs: "100%", mlg: "84%" } })
            }
          >
            <SnackbarProvider
              maxSnack={1}
              autoHideDuration={2000}
              style={{ width: "100%", height: "100%", overflow: "auto" }}
            >
              {children}
            </SnackbarProvider>
          </Container>
        </Box>
      )}

      {pageLoader ? (
        <Box
          width={"100%"}
          height={`100vh`}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          position={"fixed"}
          zIndex={1000}
          top={0}
          bgcolor={"#F5F5F5"}
        >
          <Loader />
        </Box>
      ) : (
        ""
      )}
    </>
  );
};

export default PathLayout;
const Container = styled(Box)(({ theme }) => ({
  // ...ResponsiveStyles({ width: { xs: "100%", lg: "85%" } }),

  overflow: "auto",
  backgroundColor: theme.palette.background.default,
}));
